// extracted by mini-css-extract-plugin
export default {"container":"About_container__w3NkW","allWidgets":"About_allWidgets__ex-rs","ServiceWidget":"About_ServiceWidget__YDWBe"};